(function () {
  const instances = new Set();

  function initCarousel(root) {
    if (!root) return;
    if (root.dataset.pressPostsCarouselInitialized === 'true') return;

    const track = root.querySelector('[data-press-posts-track]');
    const prev = root.querySelector('[data-press-posts-prev]');
    const next = root.querySelector('[data-press-posts-next]');
    if (!track || !prev || !next) return;

    function getGapPx() {
      const styles = window.getComputedStyle(track);
      const gap = styles.columnGap || styles.gap || '0px';
      const n = parseFloat(gap);
      return Number.isFinite(n) ? n : 0;
    }

    function getStep() {
      const firstItem = track.querySelector('.press-posts__item');
      if (!firstItem) return 0;
      const rect = firstItem.getBoundingClientRect();
      return rect.width + getGapPx();
    }

    function updateButtons() {
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      const left = track.scrollLeft;

      prev.disabled = left <= 2;
      next.disabled = left >= maxScrollLeft - 2;
    }

    root.dataset.pressPostsCarouselInitialized = 'true';
    instances.add({ root, updateButtons });

    prev.addEventListener('click', function () {
      const step = getStep();
      if (!step) return;
      track.scrollBy({ left: -step, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      const step = getStep();
      if (!step) return;
      track.scrollBy({ left: step, behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateButtons);
    });

    updateButtons();
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-press-posts-carousel]').forEach(initCarousel);
  }

  function updateAll() {
    instances.forEach(function (instance) {
      if (!instance.root.isConnected) {
        instances.delete(instance);
        return;
      }
      instance.updateButtons();
    });
  }

  window.addEventListener('resize', updateAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      updateAll();
    });
  } else {
    initAll(document);
    updateAll();
  }

  // Shopify theme editor: section DOM is replaced after initial load.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    updateAll();
  });

  document.addEventListener('shopify:section:select', function (event) {
    initAll(event.target);
    updateAll();
  });
})();

